export default __webpack_public_path__ + "static/media/cash_pooling.7df3796b.jpg";